// eslint-disable-next-line no-shadow
export enum UserType {
  SALESMAN = 1,
  CUSTOMER = 2,
  EXPO_SALESMAN = 3,
  EXPO_CUSTOMER = 4,
}